export let salesChannelReportDemoResponse: any = {
    "success": true,
    "message": "Request Completed Successfully ",
    "responseStatusCode": 903,
    "data": [
        {
            "list": [
                {
                    "couponCode": "PREMIUM55",
                    "leads": 1,
                    "signup": 0,
                    "trial": 0,
                    "lite": 0,
                    "standard": 0,
                    "plus": 0,
                    "premium": 0,
                    "custom": 0,
                    "planCost": 0.0,
                    "hardwareCost": 0.0,
                    "addons": 0.0
                }
            ]
        }
    ],
    "code": "IMS0056903",
    "totalRecords": 0,
    "elapsedTime": "16874",
    "showThisMessage": false
}